import { Avatar } from "@mui/material";
import { Upload } from "antd";
import React, { useEffect, useState } from "react";
import { CgSpinnerTwo } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";

import { PencilIcon } from "@/Components/Icons/PencilIcon";
import {
  fetchClientContactProfile,
  setContactProfileData,
  updateUser,
} from "@/reducers/clientprofile";
import { _updateProfileImage } from "@/services/clientprofile";
import { showPromiseToast } from "@/utilities/utils";

import { setSession } from "../../../../reducers/session";

/**
 * React component for displaying and updating user profile avatar.
 *
 * @return {JSX.Element} The profile avatar component
 */
const ProfileAvatar = () => {
  const dispatch = useDispatch();
  const { profileData, user, contactProfileData } = useSelector(
    (state) => state.clientProfile,
  );
  const [profileImage, setProfileImage] = useState("");
  const [profileUploading, setProfileUploading] = useState(false);
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );

  useEffect(() => {
    // const { profile } = profileData;
    setProfileImage(contactProfileData?.profile_image);
  }, [contactProfileData]);
  /**
   * Handles the change event for the file input, updates the profile image,
   * and dispatches actions to update the user profile and profile data.
   *
   * @param {type} file - the file input for the profile image
   * @return {type} the result of the profile image update
   */
  const handleChange = (file) => {
    setProfileUploading(true);
    let response = _updateProfileImage({
      client_profile_image: file.file,
    });
    showPromiseToast(response, {
      loading: "Uploading...",
      success: "Profile image updated successfully",
      error: "Failed to update profile image",
    });
    response
      .then((res) => {
        const { image_url, message } = res;
        dispatch(
          updateUser({
            profile_image: image_url,
          }),
        );
        dispatch(
          setContactProfileData({
            profile_image: image_url,
          }),
        );
        setProfileImage(image_url);
        dispatch(
          setSession({
            profile_image: image_url,
          }),
        );
        dispatch(fetchClientContactProfile());
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        setProfileUploading(false);
      });
  };
  return (
    <div className="ProfileAvatar_Wrapper">
      <div className="relative">
        <Avatar
          alt={contactProfileData && contactProfileData.contact_forename}
          src={profileImage}
          sx={{ width: 74, height: 74 }}
        />
        {!clientUserAllPermissions ||
        clientUserAllPermissions.is_allow_to_edit_profile === 1 ? (
          <>
            <Upload
              type="file"
              disabled={profileUploading}
              showUploadList={false}
              maxCount={1}
              // listType="text"
              rootClassName={`absolute top-0 left-0 w-full h-full`}
              name="client_profile_image"
              accept="image/*"
              onChange={(e) => {
                // console.log(e);
              }}
              customRequest={(file) => {
                handleChange(file);
              }}
            >
              <div
                className={`absolute bottom-0 right-0 grid h-[24px] w-[24px] place-items-center rounded-full border border-primary bg-primary text-white transition-all duration-150 ease-in ${
                  !profileUploading
                    ? "cursor-pointer hover:bg-white hover:text-primary"
                    : ""
                }`}
              >
                {profileUploading ? (
                  <CgSpinnerTwo className="buttonLoader animate-spin" />
                ) : (
                  <PencilIcon />
                )}
              </div>
            </Upload>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ProfileAvatar;
